import { connect } from 'react-redux';

import {
  getDailyQuizHistoryAction,
  getOneDailyQuizHistoryAction,
  setDailyQuizHistoryAction,
} from '../../actions/dashboardActions';
import DailyQuizHistoryView from '../../components/Dashboard/DailyQuizHistory/dailyQuizHistoryView.jsx';
import {
  getDailyQuizHistorySelector,
  getIsLoadingDailyQuizHistory,
  getLoadingReviewDailyQuiz,
  oneDailyQuizHistory,
} from '../../components/Dashboard/dashboardSelectors';

const mapStateToProps = (state, ownProps) => ({
  dailyQuizHistory: getDailyQuizHistorySelector(state),
  loadingDailyHistory: getIsLoadingDailyQuizHistory(state),
  oneDailyQuizHistory: oneDailyQuizHistory(state),
  loadingReviewDailyQuiz: getLoadingReviewDailyQuiz(state),
});
const mapDispatchToProps = (dispatch) => ({
  getDailyQuizHistory: (skip, limit, reset = false) =>
    dispatch(getDailyQuizHistoryAction(skip, limit, reset)),
  setDailyQuizHistoryAction: (history, reset = false) =>
    dispatch(setDailyQuizHistoryAction(history, reset)),
  getOneDailyQuizHistory: (id, isLastQuiz = false) =>
    dispatch(getOneDailyQuizHistoryAction(id, isLastQuiz)),
});

const DailyQuizHistoryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DailyQuizHistoryView);

export default DailyQuizHistoryContainer;
